module.exports = __webpack_public_path__ + "static/pinkunicorn1-5588fc881aae9fb9eba96d4f0896c21a.jpeg";